module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/5-7914a17cef1effb1eb044e3e18a74f52.jpg";